import { IconArrowLeft } from '../../../../../ui/icon/IconArrowLeft';
import { Button } from '../../../../../ui/input/Button';
import { Flex } from '../../../../../ui/layout/Flex';
import { Typography } from '../../../../../ui/typography/Typography';
import { getIsMobile } from '../../../../../utils/getIsMobile';
import { useBackButton } from '../../../../../utils/useBackButton';
import { useIsAdvertisingProductsCatalogEnabled } from '../../../../../utils/useIsAdvertisingProductsCatalogEnabled';
import { AdvertisingCatalogPageTitleProps } from './types';

export const AdvertisingCatalogPageTitle: React.FC<AdvertisingCatalogPageTitleProps> = ({
    title,
}) => {
    const { isMobile } = getIsMobile();
    const onNavigateBack = useBackButton();
    const enableBackButton = useIsAdvertisingProductsCatalogEnabled();

    return (
        <Flex width="100%" direction="row" alignItems="center">
            {enableBackButton && !isMobile ? (
                <Button
                    size="l"
                    width="48px"
                    variant="transparent"
                    ml={-1}
                    onClick={onNavigateBack}
                >
                    <IconArrowLeft size={24} />
                </Button>
            ) : null}
            <Typography
                variant={isMobile ? 'body' : 'title2'}
                weight="bold"
                py={2}
                pr={2}
                width="100%"
                textAlign={{ xs: 'center', sm: 'left' }}
            >
                {title}
            </Typography>
        </Flex>
    );
};
